import { NUM_PERIODS } from "./clockManager.type"

export default function updateNumOfPeriods(event) {
  return ({
    type: NUM_PERIODS,
    payload: event
  })
}